import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export default function HomeCTA() {
  const { lang } = useLanguage();

  const heading = lang === 'en'
    ? <>Ready to Upgrade Your Recycled Plastics?</>
    : lang === 'ja'
    ? <>再生プラスチックのアップグレードを始めませんか？</>
    : <>準備好升級您的再生塑料了嗎？</>;

  const body = lang === 'en'
    ? 'Whether you are a recycler, manufacturer, or brand owner, PolyQ provides tailored material solutions and technical support to help you achieve circular economy and low-carbon manufacturing goals.'
    : lang === 'ja'
    ? 'リサイクル業者・メーカー・ブランドオーナーを問わず、聚量応用材料はサーキュラーエコノミーと低炭素製造目標の達成を支援するカスタマイズされた材料ソリューションと技術サポートを提供します。'
    : '無論您是回收廠、製造廠或品牌端，聚量提供量身打造的材料解決方案與技術支援，協助您實現循環經濟與低碳製造目標。';

  const cta1 = lang === 'en' ? 'Schedule a Consultation' : lang === 'ja' ? '技術相談を予約する' : '預約技術諮詢';
  const cta2 = lang === 'en' ? 'Browse Products & Materials' : lang === 'ja' ? '製品・材料を見る' : '瀏覽產品與材料';

  const stats = lang === 'en'
    ? [{ value: '500–1000 ppm', label: 'Ultra-Low Dosage' }, { value: 'rABS / rPET / rPP', label: 'Multi-Resin Compatible' }, { value: 'ESG Ready', label: 'Carbon Reduction Certified' }]
    : lang === 'ja'
    ? [{ value: '500〜1000 ppm', label: '超低添加量' }, { value: 'rABS / rPET / rPP', label: '多樹脂対応' }, { value: 'ESG対応', label: '炭素削減認証' }]
    : [{ value: '500–1000 ppm', label: '超低添加量' }, { value: 'rABS / rPET / rPP', label: '多材質適用' }, { value: 'ESG 認證', label: '減碳效益可量化' }];

  return (
    <section className="section-padding relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #00B894 0%, #0273C2 100%)' }}>
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 20%, white 1px, transparent 1px)', backgroundSize: '60px 60px' }} aria-hidden="true" />
      <div className="relative max-w-screen-xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-bold text-white mb-5" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', lineHeight: '1.4' }}>{heading}</h2>
        <p className="text-white/85 mb-10 max-w-2xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>{body}</p>
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-brand-green text-[1.0625rem] font-bold hover:bg-neutral-light transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-calendar-schedule-line"></i>{cta1}
          </Link>
          <Link to="/products" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/15 border border-white/50 text-white text-[1.0625rem] font-semibold hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-stack-line"></i>{cta2}
          </Link>
        </div>
        <div className="flex flex-wrap justify-center gap-8 md:gap-16">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-white font-bold mb-1" style={{ fontSize: '1.5rem' }}>{s.value}</p>
              <p className="text-white/75 text-[1rem]">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
